export default "__VITE_ASSET__BhAysCCE__"